export const functionKeys = {
  LENGTH: 'length'
};

export const functionLabels = {
  [functionKeys.LENGTH]: 'Length'
};

export const functionsArray = [
  {
    value: functionKeys.LENGTH,
    label: functionLabels[functionKeys.LENGTH]
  }
];
